angular.module('unica_social_stream.social_stream_services')

.factory('SocialStreamDeleteService', function ($http, getBaseApiURL) {

	var socialStreamDeleteService = {};

	socialStreamDeleteService.delete = function (postId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/social-stream/delete/' + postId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return socialStreamDeleteService;
});